import { Post } from 'src/types/DiscussionPost';

const isPinned = (post: Post) => [
  post.pinnedToCategory,
  post.pinnedToGroup,
  post.pinnedToListing,
].includes(true);

export default isPinned;
